import palette from './colors';
import typography from './typography';

export default {
  palette,
  typography,
};
